<template>
  <div>
    <div
      v-if="label"
      class="font-medium"
      :style="labelStyle"
    >
      {{ label }}

      <span
        v-if="optional && !disabled"
        class="text-xs font-lighter italic"
      >
        <slot name="optional">{{ optionalMessage }}</slot>
      </span>

      <slot name="hint" />
    </div>

    <ul
      class="list-reset inline-flex items-center flex-wrap"
      :class="reactionsClasses"
    >
      <li
        v-for="emoji in emojis"
        :key="emoji"
        :data-emoji="dataEmoji(emoji)"
        :class="[$style.emoji, { [$style.selected]: value === emoji }]"
        @click="selectEmoji(emoji)"
      >
        <img
          :src="getImgUrl(emoji)"
          :alt="emoji + ' (static)'"
          :class="$style.initial"
        >

        <img
          :src="getGifUrl(emoji)"
          :alt="emoji + ' (animated)'"
          :class="$style.animated"
        >
      </li>
    </ul>

    <slot name="extra" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelStyle: {
      type: Object,
      default: () => ({})
    },
    optional: {
      type: Boolean,
      default: false
    },
    dataEmoji: {
      type: Function,
      default: () => {}
    }
  },

  data () {
    return {
      emojis: [
        'love',
        'lolCry',
        'wow',
        'cry',
        'angry'
      ]
    }
  },

  computed: {
    reactionsClasses () {
      let classes = [this.$style.reactions]

      if (this.disabled) {
        classes.push(this.$style.disabled)
      }

      return classes
    },

    optionalMessage () {
      return this.$t('common.formFields.fields.optional')
    }
  },

  methods: {
    selectEmoji (emoji) {
      if (!this.disabled) {
        const value = this.value !== emoji ? emoji : ''

        this.$emit('input', value)
      }
    },

    getImgUrl (emoji) {
      return require('@common/assets/emojis/' + emoji + '/initial.png')
    },

    getGifUrl (emoji) {
      return require('@common/assets/emojis/' + emoji + '/animated.gif')
    }
  }
}
</script>

<style
  lang="scss"
  module
>
.reactions {
  .emoji {
    @apply relative block cursor-pointer;

    width: 60px;
    transition: transform .3s ease-in-out;

    &:not(:last-of-type) {
      @apply mr-1;
    }

    .animated {
      @apply absolute pin-t pin-l;

      visibility: hidden;
      width: 60px;
    }

    .initial {
      filter: grayscale(95%);
      width: 60px;
    }

    &::after {
      @apply absolute rounded-full font-medium text-xs text-white px-1;

      content: attr(data-emoji);
      visibility: hidden;
      background-color: rgba(0, 0, 0, .5);
      width: fit-content;
      left: 50%;
      top: 100%;
      transform: translate(-50%, -10%);
      transition: transform .3s ease-in-out, top .3s ease-in-out;
    }

    &:hover,
    &.selected {
      transform: scale(1.2);

      &::after {
        visibility: visible;
        top: 50%;
        transform: translate(-50%, 130%);
      }

      .initial {
        visibility: hidden;
      }

      .animated {
        visibility: visible;
        display: block;
      }
    }
  }

  &.disabled {
    .emoji {
      cursor: initial;

      .initial {
        filter: grayscale(95%);
      }

      &:hover {
        transform: initial;

        .initial {
          visibility: visible;
        }

        .animated {
          visibility: hidden;
        }

        &::after {
          visibility: hidden;
        }
      }

      &.selected,
      &.selected:hover {
        transform: scale(1.2);

        .initial {
          visibility: hidden;
        }

        .animated {
          visibility: visible;
        }

        &::after {
          visibility: visible;
          top: 50%;
          transform: translate(-50%, 130%);
        }
      }
    }
  }
}
</style>
